import {Component} from '@angular/core';
import { Bind } from 'primeng/bind';
import { Button } from 'primeng/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-checkout-footer',
    templateUrl: './checkout-footer.component.html',
    imports: [
        Bind,
        Button,
        TranslatePipe,
    ],
})
export class CheckoutFooterComponent {}
